import React, {useCallback, useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom"
import { del } from '../../helpers/api_helper';
import { POST_ORDER_LIST, DELETE_ORDER } from '../../helpers/url_helper';
import { Helmet } from "react-helmet";
import { getToken } from '../../helpers/Helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';
import { CompanyContext } from '../../layouts/Default';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";

import OrderFormModal from './OrderFormModal';


const TagsList = props => {
    const { company_name } = useContext(CompanyContext);
    const [orderId, SetOrderId] = useState(0);

    const handleKeyPress = useCallback((event) => {
        if (event.keyCode === 182) {
            AddOrderModel(0);
        }
    }, []);
    
    useEffect(() => {
        get_list();
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress])

    // get list
    const get_list = () => {
        $(document).ready(function () {
            $('#dataTableExample').DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": true,
                "sServerMethod": "POST",
                "sAjaxSource": POST_ORDER_LIST,
                "order": [[0, 'desc']],
                columnDefs: [{ orderable: false, targets: [6,7] }],
                "fnServerData": function (sSource, aoData, fnCallback) {
                    $.ajax({
                        "dataType": 'json',
                        "type": "POST",
                        "url": sSource,
                        "data": aoData,
                        "success": fnCallback,
                        headers: { 'Authorization': getToken() },
                    });
                },
                "columns": [
                    { "data": "orderId" },
                    { "data": "orderDate" },
                    { "data": "companyName" },
                    { "data": "totalBox" },
                    { "data": "cityName" },
                    { "data": "reference" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {data.orderStatus === 'Pending' && <button type="button" className="border-0 badge badge-info pt-1 pb-1"  >Pending</button>}
                                {data.orderStatus === 'Confirmed' && <button type="button" className="border-0 badge badge-primary pt-1 pb-1"  >Confirmed</button>}
                                {data.orderStatus === 'Dispatched' && <button type="button" className="border-0 badge badge-success pt-1 pb-1"  >Dispatched</button>}
                                {data.orderStatus === 'Cancelled' && <button type="button" className="border-0 badge badge-danger pt-1 pb-1" >Cancelled</button>}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <button className="btn btn-sm btn-primary pt-0 pb-0 pl-1 pr-1  mr-2" onClick={AddOrderModel.bind(this,data.orderId)} ><i className="fa fa-pencil" style={{ 'fontSize': '12px' }} aria-hidden="true"></i></button>
                                <span className='dropdown print-dropdown'>
                                    <button type="button" className="btn btn-sm btn-info pt-0 pb-0 pl-1 pr-1  mr-2" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"><i className="fa fa-print" style={{ 'fontSize': '12px' }} aria-hidden="true"></i></button>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/order-design?id=${data.orderId}`} target="_blank" className="dropdown-item">Order (Design)</a>
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/order-shade-loc?id=${data.orderId}`} target="_blank" className="dropdown-item">Order (Shade-Loc)</a>
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/order-batch-shade-loc?id=${data.orderId}`} target="_blank" className="dropdown-item">Order (Batch-Shade-Loc)</a>
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/do-design?id=${data.orderId}`} target="_blank" className="dropdown-item">D.O (Design)</a>
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/do-shade-loc?id=${data.orderId}`} target="_blank" className="dropdown-item">D.O (Shade-Loc)</a>
                                        <a href={`${process.env.REACT_APP_PDF_URL}pdf/order/do-batch-shade-loc?id=${data.orderId}`} target="_blank" className="dropdown-item">D.O (Batch-Shade-Loc)</a>
                                    </div>
                                </span>
                                <button className="btn btn-sm btn-danger pt-0 pb-0 pl-1 pr-1  mr-2" onClick={() => { SetOrderId(data.orderId); }} data-toggle="modal" data-target="#deleteModal" ><i className="fa fa-trash-o" style={{ 'fontSize': '12px' }} aria-hidden="true"></i></button>
                            </>, td)
                        }
                    },
                ]
            });
        });
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_ORDER + "?orderId=" + orderId);
        if (res_data.status) {
            toast(res_data.message);
            get_list();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const AddOrderModel = async (id = 0) => {
        window.$('#orderModal').modal({ backdrop: 'static', keyboard: false });
        SetOrderId(id);
        setTimeout(() => {
            window.$("#orderDate").focus();
        }, 500);
    }
    
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{(company_name) ? company_name : ''} | Order List</title>
            </Helmet>

            <div className='row mt-3'>
                <div className='col-sm-12'>
                    <div className='card'>
                        <div className="card-header">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h6 className='mt-2 mb-0'>Order List</h6>
                                </div>
                                <div className="col-sm-6 text-right">
                                    <button type="button" onClick={AddOrderModel.bind(this,0)} className="btn btn-sm btn-primary pt-1 pb-1 pl-3 pr-3 c-btn-primary text-white">+ Add (F2)</button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className="mt-2 mb-5">
                                <table id="dataTableExample" className="table table-striped  table-align-center">
                                    <thead>
                                        <tr>
                                            <td>Ord No.</td>
                                            <td>Date</td>
                                            <td>Customer</td>
                                            <td>Qty</td>
                                            <td>City</td>
                                            <td>Ref.Party</td>
                                            <td>Status</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete this record?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-sm btn-dnager c-btn-danger text-white" data-dismiss="modal">No</button>
                                <button onClick={remove_row.bind(this)} data-dismiss="modal" className="btn btn-sm btn-primary c-btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <OrderFormModal call_back={get_list} editId={orderId} orderType={'Order'}/>
        </>
    );
}
export default withRouter(TagsList)
